import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUpload } from '@fortawesome/pro-duotone-svg-icons';

const AddFileButton = ({
  className,
  labelClassName,
  getFilesFromEvent,
  accept,
  onFiles,
  disabled,
  tab,
}) => {
  const fileInput = React.useRef(null);

  const handleClick = () => {
    fileInput.current.click();
  };

  return (
    <Button
      color="dark"
      className="text-capitalize position-relative"
      disabled={disabled}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faCloudUpload} fixedWidth size="lg" className="me-2" />
      {`Upload ${tab} File`}

      <label className={labelClassName} htmlFor="upload-button">
        <input
          id="upload-button"
          ref={fileInput}
          className={className}
          type="file"
          accept={accept}
          onChange={async (event) => {
            const { target } = event;
            const chosenFiles = await getFilesFromEvent(event);
            onFiles(chosenFiles);
            target.value = null;
          }}
          disabled={disabled}
        />
      </label>
    </Button>
  );
};

const mapStateToProps = (store) => ({
  tab: store.batch.tab,
  disabled: !store.batch.ready,
});

export default connect(mapStateToProps)(AddFileButton);
